// components/ui/textarea.jsx
import React from "react";

/**
 * Textarea Component
 * 
 * A styled textarea component.
 * 
 * @component
 * @example
 * <Textarea placeholder="Enter text..." rows={4} />
 */
const Textarea = ({ className = "", ...props }) => {
  return (
    <textarea
      className={`flex min-h-[80px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
      {...props}
    />
  );
};

export default Textarea;
